import { axios } from 'lib/axios';

export const loginWithGithub = ({ code }) => {
  return axios.get(`/v2/oauth/github/callback?code=${code}`);
};
